// extracted by mini-css-extract-plugin
export var AutomotiveNew = "index-module--AutomotiveNew--ci5pf";
export var Banner = "index-module--Banner--dEPAu";
export var BannerSlot = "index-module--BannerSlot--aoTBO";
export var Card = "index-module--Card--4pw5W";
export var CargoCard = "index-module--CargoCard--ccfGm";
export var CourseCard = "index-module--CourseCard--gJRgB";
export var automotiveBanner = "index-module--automotiveBanner--Olkr8";
export var automotiveNewFooter = "index-module--automotiveNewFooter--3n-4A";